import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import Ellipse1 from '../../assets/customer/Ellipse_1.svg';
import Ellipse2 from '../../assets/customer/Ellipse_2.svg';
import Ellipse3 from '../../assets/customer/Ellipse_3.svg';
import Ellipse4 from '../../assets/customer/Ellipse_4.svg';
import Ellipse5 from '../../assets/customer/Ellipse_5.svg';
import Ellipse6 from '../../assets/customer/Ellipse_6.png';
import { ArticleSwiperHome } from '../../components/Article_Swiper';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import TravelPartner from '../../components/travel_partner';
import BottomSignupGradient from '../../components/bottom_signup_gradient';
import AppNavBar from '../../helper/appbar';

// SVGs Desktop Version
import HomeSVG1a from '../../assets/home/Kardinal.svg';
import InventorySVG from '../../assets/home/Inventory.svg';
import FlexibleTrips from '../../assets/home/Flexible_Trips.svg';
import ManageExpenses from '../../assets/home/ManageExpenses.svg';
import kCare from '../../assets/home/K-Care.svg';
import kCareHome from '../../assets/home/K-care_home.svg';
import kCareHomeMb from '../../assets/home/Kcare_home_mobile.svg';

// CSS
import './home.css';
import { useNavigate } from 'react-router-dom';
const Home = () => {
  const navigate = useNavigate();

  // Take email to demo form
  const submitEmail = (event) => {
    event.preventDefault();
    const email = new FormData(event.currentTarget);
    navigate("/demo", { state: { email: email.get("email") } });
  };
  return (
    <main className='home-main'>
      <AppNavBar navType={'dark'} />

      <section className='home-section-01'>
        <Container>
          <Row>
            <Col md={12} lg={6} className="home-sec-sub1">
              <h1>Save time and money for your business travel.</h1>
              <p>A simple platform for managing your travel, expenses and much more.</p>
              <form onSubmit={submitEmail}>
                <input type="email" placeholder='Your work email' name={"email"} />
                <button>Request demo</button>
              </form>
              <ul>
                <li>Reconciliation and management</li>
                <li>No extra fee</li>
                <li>Reconciliation and management</li>
                <li>Credit</li>
              </ul>
            </Col>
            <Col md={12} lg={6} className="home-sec-sub-2">
              <img src={HomeSVG1a} alt="home-sec1-svg" loading='lazy' />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home-section-02'>
        <Container>
          <Row>
            <Col className='home-sec2-cont'>
              <h1>Complete travel solution for your business</h1>
              <p>Easily manage bookings, track expenses, generate invoices and reports, and gather valuable data on your business trips.</p>
              <p>Easily manage bookings, track expenses, generate <br /> invoices and reports, and gather valuable data <br /> on your business trips.</p>
            </Col>
          </Row>
          <Row>
            <Col className='home-sec2-cont1'>
              <aside className='home-sec2-aside1'>
                <div className='shaded_area'>
                  <h4>Largest Inventory</h4>
                  <p>Plan a trip, rent a car, arrange accommodation, and
                    choose the option that best fits your budget.</p>
                  <button onClick={() => navigate("/travel")}>Start with travel <ExpandCircleDownIcon /></button>
                </div>
                <img src={InventorySVG} alt='home-sec2' loading='lazy' className='box__svgs abs-svg' />
              </aside>
              <aside className='home-sec2-aside2'>
                <h4>Flexible trips.
                  Flexible Payment</h4>
                <p>Enjoy our credit technology tailored for businesses.
                  Easily pay with your card, or add money to your
                  wallet to get more rewards.</p>
                <button onClick={() => window.open("http://app.gokardinal.com/onboarding", "_blank")}>Get credit <ExpandCircleDownIcon /></button>
                <img src={FlexibleTrips} alt='home-sec2' loading='lazy' className='box__svgs extra-width' />
              </aside>
            </Col>
          </Row>
          <Row>
            <Col className='home-sec2-cont2'>
              <aside className='home-sec2-aside3'>
                <h4>Expense Managment</h4>
                <p>Personalize payments, track expenses, and get
                  real-time insights into your business trips from
                  one dashboard.</p>
                <button onClick={() => navigate("/expense-management")}>Start with Expense Managment <ExpandCircleDownIcon /></button>
                <img src={ManageExpenses} alt='home-sec2' loading='lazy' className='box__svgs extra-width' />
              </aside>
              <aside className='home-sec2-aside4'>
                <h4>K Care</h4>
                <p>Comprehensive security, regulatory and safety
                  support at every stage of your journey. Sign up
                  now.</p>
                <button onClick={()=> navigate("/k-care")}>Visit K-Care <ExpandCircleDownIcon /></button>
                <img src={kCare} alt='home-sec2' loading='lazy' className='box__svgs' />
              </aside>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home_section_3'>
        <button>Hear from them</button>
        <h1>What businesses are saying about using Kardinal</h1>
        <Container fluid>
          <Row>
            <Col sm={6} lg={5}>
              <section>
                <img src={Ellipse1} alt="home_brands" />
                <img src={Ellipse2} alt="home_brands" />
                <img src={Ellipse3} alt="home_brands" />
              </section>
              <section>
                <img src={Ellipse4} alt="home_brands" />
                <img src={Ellipse5} alt="home_brands" />
                <img src={Ellipse6} alt="home_brands" />
              </section>
            </Col>
            <Col sm={6} lg={7} className="home_sec3_article_side">
              <aside>
                <ArticleSwiperHome spaceBetween={18} slidesPerView={2} />
                <button onClick={()=> navigate("/customer")}>Customers stories <ExpandCircleDownIcon /> </button>
                <ArticleSwiperHome spaceBetween={15} slidesPerView={1} />
              </aside>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home_section_4'>
        <Container fluid>
          <Row>
            <Col sm={12} lg={6}>
              <h1>K-Care, Travel information at your fingertips</h1>
              <div>
                <img src={kCareHomeMb} alt="home-kcare" />
              </div>
              <ul>
                <li>Dedicated customer support for your concerns.</li>
                <li>Confirm all necessary documents before your trip.</li>
                <li>Instant visa and consulate requirement support.</li>
                <li>Automated updates on every location you are visiting.</li>
              </ul>
            </Col>
            <Col sm={12} lg={6} className='home_kcare'>
              <img src={kCareHome} alt="home-kcare" />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home_section_5'>
        <h1>Access Kardinal anytime, anywhere, on any device</h1>
        <div className='home-desktop-sec5'>
          <aside>
            <div>
              <h5>Flights</h5>
              <p>Simple and user friendly
                flight result.</p>
            </div>
            <div>
              <h5>Invoice</h5>
              <p>Automatic invoicing system</p>
            </div>
            <div>
              <h5>Reporting</h5>
              <p>Actionable data for all your activities</p>
            </div>
          </aside>
        </div>
        <div className='home-mobile-sec5'>
          <div className='mobile1'>
            <p>w</p>
          </div>
          <div className='mobile2'>
            <p>w</p>
          </div>
          <div className='mobile3'>
            <p>w</p>
          </div>
        </div>
      </section>

      <TravelPartner />

      {/* Section 5th */}
      <section className='home_section_6'>
        <BottomSignupGradient
          type={`Save cost on travel & expense`}
        />
      </section>
    </main>
  );
};
export default Home;